import React from 'react'
import styled from 'styled-components'
import { LG } from '@zendeskgarden/react-typography'
import { Row } from '@zendeskgarden/react-grid'

// Product Tray (PT) Icons
import PTSupportIcon from '@zendeskgarden/svg-icons/src/26/tray-headset.svg'
import PTKnowledgeIcon from '@zendeskgarden/svg-icons/src/26/tray-book.svg'
import PTAIAgentsIcon from '@zendeskgarden/svg-icons/src/26/tray-bot-sparkle.svg'
import PTChatIcon from '@zendeskgarden/svg-icons/src/26/tray-speech-bubble.svg'
import PTVoiceIcon from '@zendeskgarden/svg-icons/src/26/tray-phone.svg'
import PTAnalyticsIcon from '@zendeskgarden/svg-icons/src/26/tray-bar-chart.svg'
import PTWFMIcon from '@zendeskgarden/svg-icons/src/26/tray-calendar.svg'
import PTQAIcon from '@zendeskgarden/svg-icons/src/26/tray-clipboard.svg'
import PTCommunictyIcon from '@zendeskgarden/svg-icons/src/26/tray-user-group.svg'
import PTSalesIcon from '@zendeskgarden/svg-icons/src/26/tray-growth-chart.svg'
import PContactCenterIcon from '../../assets/icons/product-contact-center.svg'

const PTSupportIconWrapper = styled(PTSupportIcon)`
  margin-right: 1em
`

const PTKnowledgeIconWrapper = styled(PTKnowledgeIcon)`
  margin-right: 1em
`

const PTAIAgentsIconWrapper = styled(PTAIAgentsIcon)`
  margin-right: 1em
`

const PTChatIconWrapper = styled(PTChatIcon)`
  margin-right: 1em
`

const PTVoiceIconWrapper = styled(PTVoiceIcon)`
  margin-right: 1em
`

const PTAnalyticsIconWrapper = styled(PTAnalyticsIcon)`
  margin-right: 1em
`

const PTWFMIconWrapper = styled(PTWFMIcon)`
  margin-right: 1em
`

const PTQAIconWrapper = styled(PTQAIcon)`
  margin-right: 1em
`

const PTCommunityIconWrapper = styled(PTCommunictyIcon)`
  margin-right: 1em
`

const PTSalesIconWrapper = styled(PTSalesIcon)`
  margin-right: 1em
`

const PContactCenterIconWrapper = styled(PContactCenterIcon)`
  margin-right: 1em
`

const StyledServiceRow = styled(Row)`
  justify-content: space-between
  display: inline-block
  padding-left: 10px
`

const StyledDiv = styled(LG)`
  justify-content: space-between
  height: 25px
  line-height: 25px
`

// Product Tray Icons
const StyledIcons = ({ lowerName }) => {
  switch (lowerName) {
    case 'support':
      return(
        <PTSupportIconWrapper />
      )
    case 'knowledge':
      return(
        <PTKnowledgeIconWrapper />
      )
    case 'ai agents':
      return(
        <PTAIAgentsIconWrapper />
      )
    case 'chat':
      return (
        <PTChatIconWrapper />
      )
    case 'voice':
      return (
        <PTVoiceIconWrapper />
      )
    case 'analytics':
      return (
        <PTAnalyticsIconWrapper />
      )
    case 'workforce management':
      return (
        <PTWFMIconWrapper />
      )
    case 'quality assurance':
      return (
        <PTQAIconWrapper />
      )
    case 'community':
      return (
        <PTCommunityIconWrapper />
      )
    case 'sales':
      return (
        <PTSalesIconWrapper />
      )
    case 'contact center':
      return (
        <PContactCenterIconWrapper />
      )
    default:
      return (
        <div />
      )
  }
}

const ProductTags = ({ lowerName, serviceName }) => {
  return (
    <StyledServiceRow>
      <StyledIcons lowerName={lowerName} />
      <StyledDiv>{serviceName}</StyledDiv>
    </StyledServiceRow>
  )
}

/**
 * Generates Horizontal aligned brand logos for services given service name
 */
const BrandedLogos = ({ serviceName }) => {
  const lowerName = serviceName.toString().toLowerCase()

  return (
    <ProductTags lowerName={lowerName} serviceName={serviceName} />
  )
}

export default BrandedLogos
